import { useEffect } from "react"
import { useUIStore } from "@/store/ui.store"

export function ThemeApplier() {
  const theme = useUIStore((s) => s.theme)

  useEffect(() => {
    const root = document.documentElement
    if (theme === "dark") {
      root.classList.add("dark")
    } else {
      root.classList.remove("dark")
    }
    // Update meta theme-color
    const meta = document.getElementById("meta-theme-color") as HTMLMetaElement | null
    if (meta) {
      meta.content = theme === "dark" ? "#060c1a" : "#f7f9fc"
    }
  }, [theme])

  return null
}
